import Logo from '@/assets/icons/logo.svg';
import LogoutIcon from '@/assets/icons/logout.svg';
import { useAppStore, useAuthStore } from '@/stores';
import { DownOutlined, UserOutlined } from '@ant-design/icons';
import type { MenuProps } from 'antd';
import { Avatar, Dropdown, Layout } from 'antd';
import React, { useState } from 'react';
import ConfirmModal from '@/components/common/ConfirmModal';

const { Header: AntHeader } = Layout;

const Header: React.FC = () => {
  const { user, logout } = useAuthStore();
  const { sidebarCollapsed } = useAppStore();
  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);

  const userMenuItems: MenuProps['items'] = [
    {
      key: 'logout',
      icon: <img src={LogoutIcon} className="!ml-1 !mr-0" alt="logout" style={{ width: 24, height: 24 }} />,
      label: (
        <span style={{ color: '#EC0000', fontWeight: 'bold' }}>
          ログアウト
        </span>
      ),
      className: "flex flex-row-reverse",
      rootClassName:"user-logout-menu-item",
    },
  ];

  const handleMenuClick: MenuProps['onClick'] = ({ key }) => {
    if (key === 'logout') {
      setIsLogoutModalOpen(true);
    }
  };

  const handleLogoutConfirm = () => {
    setIsLogoutModalOpen(false);
    void logout();
  };

  const handleLogoutCancel = () => {
    setIsLogoutModalOpen(false);
  };

  return (
    <>
      <AntHeader
        className="header-container"
        style={{
          left: sidebarCollapsed ? 80 : 300,
        }}
      >
        {/* Left - Logo & Project Name */}
        <div className="header-left">
          <img src={Logo} alt="Logo" width={40} height={40} />
          <span className="header-title">てらびより</span>
        </div>

        {/* Right - User Menu */}
        <Dropdown
          menu={{ items: userMenuItems, onClick: handleMenuClick }}
          trigger={['click']}
          placement="bottomRight"
          rootClassName="header-user-dropdown"
          align={{ offset: [-15, 10] }}
        >
          <div className="header-user">
            <Avatar src={user?.avatar} icon={!user?.avatar && <UserOutlined />} size={36} />
            <div className="header-user-info">
              <span className="header-user-role">管理者</span>
              <span className="header-user-name">{user?.name || 'アン・フインミン'}</span>
            </div>
            <DownOutlined className="header-user-arrow" />
          </div>
        </Dropdown>
      </AntHeader>

      <ConfirmModal
        open={isLogoutModalOpen}
        onClose={handleLogoutCancel}
        onConfirm={handleLogoutConfirm}
        title="通知"
        message="ログアウトしますか？"
        confirmText="はい"
        cancelText="いいえ"
        variant="confirm"
      />
    </>
  );
};

export default Header;

